<template>
    <!-- Componente para mostrar los pasos de la pre autorización de crédito y resaltar el paso en el que se encuentra el usuario -->
    <div class="flex justify-center items-center mt-6 mb-6">
        <div
            :class="actualForm >= 1 ? 'bg-light-blue' : 'bg-brown'"
            class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white"
        >1</div>
        <div class="font-medium -mt-2">....</div>
        <div
            :class="actualForm >= 2 ? 'bg-light-blue' : 'bg-brown'"
            class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white"
        >2</div>
        <div class="font-medium -mt-2">....</div>
        <div
            :class="actualForm >= 3 ? 'bg-light-blue' : 'bg-brown'"
            class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white"
        >3</div>
        <div class="font-medium -mt-2">....</div>
        <div
            :class="actualForm === 4 ? 'bg-light-blue' : 'bg-brown'"
            class="rounded-full w-5 lg:w-6 text-center text-sm lg:text-base leading-none py-1 font-medium text-white"
        >4</div>
    </div>
</template>

<script>
export default {
    props: ["actualForm"],
};
</script>

<style>

</style>